import { childMediaQuery } from '~/js/helpers';

const anchorMenus = document.querySelectorAll('.anchor-menu');
const siteHeader = document.querySelector('#site-header');
let headerHeight = document.querySelector('#site-header') ? document.querySelector('#site-header').offsetHeight : 80;
let prevScrollPos = window.scrollY;

// Admin bar offset
if (document.querySelector('#wpadminbar')) {
	headerHeight += document.querySelector('#wpadminbar').offsetHeight;
}

// Floating header offset
if (document.body.classList.contains('float-header')) {
	const floatOffset = parseFloat(
		getComputedStyle(document.documentElement).getPropertyValue('--strl-header-float-offset')
	);

	if (!Number.isNaN(floatOffset)) {
		headerHeight += floatOffset;
	}
}

window.addEventListener('scroll', function () {
	if (!childMediaQuery('lg-up')) {
		return;
	}

	const stickyHeader = document.querySelector('[data-sticky-nav]');

	if (!stickyHeader) {
		return;
	}

	if (window.scrollY > headerHeight) {
		stickyHeader.classList.add('is-sticky');
		anchorMenus?.forEach((menu) =>
			menu.classList.add('top-0!', '[.admin-bar_&]:top-(--wp-admin--admin-bar--height)!')
		);
	} else {
		stickyHeader.classList.remove('is-sticky');
		anchorMenus?.forEach((menu) =>
			menu.classList.remove('top-0!', '[.admin-bar_&]:top-(--wp-admin--admin-bar--height)!')
		);
	}

	const currentScrollPos = window.scrollY;

	if (prevScrollPos > currentScrollPos) {
		// user has scrolled up
		stickyHeader.classList.add('show');
	} else if (window.scrollY > headerHeight) {
		// user has scrolled down
		stickyHeader.classList.remove('show');
	}

	prevScrollPos = currentScrollPos;
});
